import * as React from "react";
import { Helmet } from "react-helmet";
import { withPrefix } from "gatsby";
//import { MDXrenderer } from 'gatsby-plugin-mdx'
// import { ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax'
import Hero from "./../components/hero/hero";
import HeroQuote from "./../components/hero/hero-quote";
import HeroVideos from "./../components/hero/hero-videos";
import Region from "./../components/regions/regional-overview-fr.js";
import Title from "./../components/title/title";
import Interactive from "./../components/graphics/interactive";
import Zoomable from "./../components/graphics/zoomable";
import SelectReport from "./../components/downloads/selection-fr";
import YouTubeVideo from "../components/video/embed-video";
import ShowModal from "../components/modal/modal-fr";
import ShowModalInfog from "../components/modal/modalinfographic.js";
import DownloadPub from "../components/downloads/publications-fr";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import "./../style.scss";
// import AppBarNoMenu from './../components/appbarextended/appbarwithoutmenu'
// import ExtendedCountdown from './../components/countdown/extendedcountdown'
// import { darkBlue } from './../assets/scss/variables.module.scss'
//import AppBarMenu from './../components/appbarextended/appbarwithmenu'
import logo from "./../images/IDMC_logo_white.svg";
//import socialmediaimage from './../images/grid2022_cover.jpg'
import JSONData from "./../content/jsonfile-fr.json";
// import VisibilitySensor from 'react-visibility-sensor'
import Footer from "../components/hero/footer-fr";
import PictureAsPdfIconOutlined from "@mui/icons-material/PictureAsPdfOutlined";

// import coverImage from 'https://www.internal-displacement.org/sites/default/files/GRID22_cover_img_edited%202.jpg'
// import scrollTo from 'gatsby-plugin-smoothscroll'
import Fade from "react-reveal/Fade";
// import { StaticImage } from 'gatsby-plugin-image'
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";

// import GlobalMap from './../images/svg/globalmap2021.svg'
//G6_ND_25_2021RGB2Spiral-01
import Spiral from "./../images/svg/G6_ND_25_2021RGB2Spiral-01 - Copy-fr.svg";
import SpiralMobile from "./../images/mobile_png/IDMC_GRID_2022 Les vingt-cinq pays ayant enregistré le plus grand nombre de déplacements internes en 2021.jpg";
import SpiralDld from "./../images/downloadable/GRID22-25-countries-fr.png";

// import Breakdown from './../images/svg/G7_ND_Breadown_ConflictDisastersRGB copy.svg'
import BreakdownMobile from "./../images/mobile_png/IDMC_GRID_2022 Répartition des déplacements internes par conflit, violence et catastrophe en 2021 v.jpg";
import BreakdownMobilePortrait from "./../images/mobile_png/IDMC_GRID_2022 Répartition des déplacements internes par conflit, violence et catastrophe en 2021 h.jpg";
import BreakddownDld from "./../images/downloadable/GRID22-breakdown-fr.png";

// import Age from './../images/mobile_png/G4_IDPS_Globally_2020 age groupRGB.jpg'
//G6_ND_25_2021RGB2Spiral
//import Globe_Ssa from './../images/svg/globes/displacements-region-pie-sub_saharan_africa.svg'
import Quote1 from "./../images/background-images/P1_Foreword_CMYK_Iraq.jpg";
import Quote2 from "./../images/background-images/P9-10_740A1478.jpg";
import Quote3 from "./../images/background-images/P49-50_GettyImages-1233122089.jpg";
import Quote4 from "./../images/background-images/P53_UN0570020.jpg";
//import Quote5 from './../images/background-images/P86_GettyImages-1371333006.jpg'
import Quote6 from "./../images/background-images/P118_740A2125_edited.jpg";
import Quote7 from "./../images/background-images/GettyImages-1236933621.jpg";
import Quote8 from "./../images/background-images/P87-88_GettyImages-1234025493.jpg";

import Alexandra from "./../images/spokespeople/Alexandra.jpg";
import Jan from "./../images/spokespeople/Jan.jpg";
import Bina from "./../images/spokespeople/Bina.jpg";
import Vicente from "./../images/spokespeople/Vicente.jpg";
import Vincent from "./../images/spokespeople/Vincent.jpg";
import Ivana from "./../images/spokespeople/Ivana.jpg";
import Ricardo from "./../images/spokespeople/Ricardo.jpg";

import globe_am from "./../images/svg/globes/G1_ND_A_PerRegion_ConflictDisasters.CMYK.png";
import globe_eap from "./../images/svg/globes/G1_ND_EAP_PerRegion_ConflictDisasters6RGB.png";
import globe_eca from "./../images/svg/globes/G1_ND_ECA_PerRegion_ConflictDisasters5RGB.png";
import globe_mena from "./../images/svg/globes/G1_ND_MENA_PerRegion_ConflictDisasters4RGB.png";
import globe_sa from "./../images/svg/globes/G1_ND_SA_PerRegion_ConflictDisasters3RGB.png";
import globe_ssa from "./../images/svg/globes/G1_ND_SSA_PerRegion_ConflictDisasters2RGB.png";

import map_global_svg from "./../images/svg/globalmap2022-2-01-fr.svg";
import map_global from "./../images/mobile_png/IDMC_GRID_2022 Déplacements internes à la suite de conflits et de catastrophes en 2021.jpg";
import map_global_dld from "./../images/downloadable/GRID22-global-map-fr.png";
import map_conflict_svg from "./../images/svg/GRID2022 Stock Conflict RGBlight - Simplify-01-fr.svg";
import map_conflict from "./../images/mobile_png/IDMC_GRID_2022 Nombre total de PDI à la suite de conflits et de violences au 31 décembre 2021.jpg";
import map_conflict_dld from "./../images/downloadable/GRID22-map-conflict-fr.png";
import map_disasters_svg from "./../images/svg/GRID2022 Stock Disasters RGBlight - Simplify-01-fr.svg";
import map_disasters from "./../images/mobile_png/IDMC_GRID_2022 Nombre total de PDI à la suite de catastrophes au 31 décembre 2021.jpg";
import map_disasters_dld from "./../images/downloadable/GRID22-map-disasters-fr.png";
import map_youth_svg from "./../images/svg/GRID2022 Stock IDPs0-24 RGBlight - Simplify-01-fr.svg";
import map_youth from "./../images/mobile_png/IDMC_GRID_2022 Nombre total d’enfants en situation de déplacement interne à la suite de conflits, de violences et de catastrophes au 31 décembre 2021.jpg";
import map_youth_dld from "./../images/downloadable/GRID22-map-youth-fr.png";
import read_data_conflict from './../images/downloadable/GRID22-how-to-read-data-conflict-fr.png'
import read_data_disasters from './../images/downloadable/GRID22-how-to-read-data-disasters-fr.png'

import glance_idp from "./../images/mobile_png/IDMC_GRID_2022 En bref-Nombre total de PDI.jpg";
import glance_internaldisplacement from "./../images/mobile_png/IDMC_GRID_2022 En bref-Déplacements internes en 2021.jpg";
import glance_internaldisplacement_graph from "./../images/mobile_png/IDMC_GRID_2022 Déplacements internes à la suite de conflits, de violences et de catastrophes par région.jpg";
import glance_totalidp_graph from "./../images/mobile_png/IDMC_GRID_2022 Nombre total de PDI dans le monde fin 2021, par tranche d’âge.jpg";

import cover3d from "./../images/grid2022-cover3d.png";

import gridhero from "./../images/grid2022_hero.jpg";
// import img_specialfeature from './../images/P91_DMA10818-comp.jpg'
import ShowModalGlance from "../components/modal/modalglance";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
//import ScrollSpy from 'react-ui-scrollspy'
import PubData from "./../content/json-publicationslinks-fr.json";
// import {BrowserRouter as Router} from 'react-router-dom';
// import { useSearchParams } from "react-router-dom";

// markup
const IndexPageDev = ({ data }) => {
  // const read_data_conflict =
  // "./../images/downloadable/GRID22-how-to-read-data-conflict-fr.png";
  // const read_data_disasters =
  // "./../images/downloadable/GRID22-how-to-read-data-disasters-fr.png";
  //const banner =
  //   'https://www.internal-displacement.org/sites/default/files/2022-04/idmc_grid22_cover_website_150dpi.jpg'

  const countrylistoptions = [];
  const countrylist = [
    "AFG",
    "ARM",
    "AZE",
    "BGD",
    "BIH",
    "BRA",
    "BFA",
    "BDI",
    "KHM",
    "CMR",
    "CAF",
    "TCD",
    "CHL",
    "CHN",
    "COL",
    "CYP",
    "COD",
    "ECU",
    "ETH",
    "GEO",
    "GTM",
    "HTI",
    "HND",
    "IND",
    "IDN",
    "IRQ",
    "ISR",
    "JPN",
    "LBY",
    "MDG",
    "MYS",
    "MLI",
    "MEX",
    "MOZ",
    "MMR",
    "NPL",
    "NER",
    "NGA",
    "PAK",
    "PSE",
    "PNG",
    "PHL",
    "SLV",
    "SOM",
    "SSD",
    "LKA",
    "SDN",
    "SYR",
    "TUR",
    "UGA",
    "UKR",
    "VNM",
    "YEM",
  ];

  countrylist.forEach((element, index) => {
    countrylistoptions.push({
      label: `${PubData[element][0]}`,
      value: `${element}`,
    });
  });

  return (
    <>
      <main>
        <Helmet
          bodyAttributes={{
            "data-bs-spy": "scroll",
            "data-bs-target": "navbarIDMC",
            "data-bs-offset": "150",
          }}
        >
          <meta charSet="utf-8" />
          <title>
            IDMC | GRID 2022 | 2022 Global Report on Internal Displacement
          </title>
          <meta
            name="description"
            content="The world’s leading source of data and analysis on the risk, scale and impacts of internal displacement"
          />{" "}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@IDMC_Geneva" />
          <meta
            name="twitter:title"
            content="2022 Global Report on Internal Displacement"
          />
          <meta
            name="twitter:image"
            content="https://www.internal-displacement.org/sites/default/files/styles/social_media_style/public/2022-05/grid2022_cover.jpg?itok=ui5O8tmW"
          />
          <meta
            property="og:title"
            content="2022 Global Report on Internal Displacement"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:image"
            content="https://www.internal-displacement.org/sites/default/files/2022-05/grid2022_cover.jpg"
          />
          {/* <link
            rel='canonical'
            href='https://internal-displacement.org/global-report/grid2022/'
          /> */}
          <script
            src={withPrefix("tooltip-fr.js?v0.0.3")}
            type="text/javascript"
            defer
          />
          {/* <script src={withPrefix('scrollspy.js')} type='text/javascript' /> */}
        </Helmet>

        <title>IDMC | GRID 2022 </title>
        {/* <AppBarMenu /> */}
        <div>
          <Hero
            imageUrl={gridhero}
            id="hero2"
            txtColor="#ffffff"
            bgColor="#0a3758"
            bgOpacity="0.3"
            copyright="© Illustration de Matt Murphy, avril 2022"
          >
            <Container maxWidth="sm">
              <img src={logo} width="199px" alt="IDMC logo" />
              <h1 className="mt-5">
                Rapport mondial sur le déplacement interne 2022
              </h1>
              <p>
                Le Rapport mondial sur le déplacement interne (GRID) de l’IDMC
                est la principale source mondiale de données et d’analyses sur
                le déplacement interne. L’édition de cette année met l’accent
                sur les enfants et les jeunes en situation de déplacement
                interne.
              </p>
              <p>
                <a href="#part1" className="whitetext">
                  La partie 1
                </a>{" "}
                présente des données et une analyse actualisées des déplacements
                internes au niveau mondial. Les données et les mises à jour
                contextuelles sont incluses dans les aperçus régionaux et les
                sections « En détail » des différents pays.
              </p>
              <p>
                <a href="#part2" className="whitetext">
                  La partie 2
                </a>{" "}
                étudie les effets du déplacement sur les enfants et les jeunes,
                si souvent invisibles dans les données sur le sujet, tout en
                mettant en lumière les initiatives prometteuses qui répondent à
                certains de leurs défis.
              </p>
            </Container>
          </Hero>
          <nav
            className="navbar navbar-expand-lg navbar-dark fixed-top pt-0"
            id="navbarIDMC"
            style={{ flexDirection: "column" }}
          >
            <div
              className="container-fluid mb-2"
              style={{ background: "#008dc9" }}
            >
              <div
                className="container"
                style={{ justifyContent: "center", display: "flex" }}
              >
                <a
                  className="nav-link"
                  href="https://www.internal-displacement.org/global-report/"
                >
                  Éditions précédentes
                </a>{" "} <a
                  className="nav-link"
                  href={withPrefix("")}
                >
                  English
                </a>{" "}  <a
                  className="nav-link"
                  href={withPrefix("spanish")}
                >
                  Español
                </a>{" "}  <a
                  className="nav-link"
                  href="https://www.internal-displacement.org/sites/default/files/2022-10/IDMC_GRID%202022_AR_LowRes.pdf"  style={{direction:"rtl"}}
                >
                  العربية 
                </a>
              </div>
            </div>
            <div className="container">
              <a
                className="navbar-brand"
                href="https://www.internal-displacement.org"
              >
                &lt; Retour sur le site de l’IDMC
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="nav navbar-nav me-auto ms-lg-auto mb-2 mb-lg-0">
                  <li className="nav-item">
                    <a className="nav-link" href="#at-a-glance">
                      En bref
                    </a>
                  </li>
                  {/* <li className="nav-item">
          <a className="nav-link" href="#">Link</a>
        </li> */}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#part1"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      Partie 1 : Vue d’ensemble
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <li>
                        <a className="dropdown-item" href="#part1">
                          Partie 1 : Vue d’ensemble
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#spiral">
                          Les vingt-cinq pays les plus touchés par les
                          déplacements internes
                        </a>
                      </li>
                      {/* <li><hr className="dropdown-divider" /></li> */}
                      <li>
                        <a className="dropdown-item" href="#breakdown">
                          Répartition par conflits et catastrophes{" "}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#people-living-in-displacement"
                        >
                          Personnes vivant en situation de déplacement interne{" "}
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#regional-overviews">
                          Aperçus régionaux
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#part2">
                      Partie 2 : Enfants et jeunes en situation de déplacement
                      interne
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link border rounded p-2" href="#download">
                      Télécharger le rapport
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#mediapack">
                      Dossier média
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <div>
            <Fade>
              <Container maxWidth="lg" id="at-a-glance">
                <Title h4="En bref"></Title>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h4>Déplacements internes en 2021</h4>
                    <img
                      src={glance_internaldisplacement}
                      alt="38 millions – 14,4 millions à la suite de conflits et de violences Déplacements internes 23,7 millions à la suite de catastrophes "
                      style={{ maxWidth: "400px" }}
                    />
                    <div className="d-none d-lg-block">
                      <ShowModalGlance
                        name="At a glance - Internal displacements by conflict, violence and disasters worldwide (2012-2021)"
                        id="glance_internaldisplacement_graph"
                        img={glance_internaldisplacement_graph}
                      />
                    </div>
                    <div className="d-lg-none">
                      <Zoomable
                        src={glance_internaldisplacement_graph}
                        alt="At a glance - Internal displacements by conflict, violence and disasters worldwide (2012-2021)"
                        caption=""
                        zoom="200"
                        dld={glance_internaldisplacement_graph}
                        interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                        download="Télécharger l’infographie"
                      />
                    </div>
                    <p className="small" style={{ color: "#636363" }}>
                      * En raison des arrondis, certains totaux peuvent ne pas
                      correspondre à la somme des chiffres individuels.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h4>Nombre total de PDI </h4>
                    <img
                      src={glance_idp}
                      alt="59.1 million internally displaced people - 53.2m by conflict and violence, 5.9m by disasters"
                      style={{ maxWidth: "400px" }}
                    />{" "}
                    <div className="d-none d-lg-block">
                      <ShowModalGlance
                        name="At a glance - Total number of IDPs worldwide at year end (2012-2021)"
                        id="glance_totalidp_graph"
                        img={glance_totalidp_graph}
                      />
                    </div>
                    <div className="d-lg-none">
                      <Zoomable
                        src={glance_totalidp_graph}
                        alt="At a glance - Total number of IDPs worldwide at year end (2012-2021)"
                        caption=""
                        zoom="200"
                        dld={glance_totalidp_graph}
                        interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                        download="Télécharger l’infographie"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <h4>Comment interpréter nos données</h4>
                  </div>
                  <div className="col-md-6">
                    <ShowModalGlance
                      name="How to read our data - conflict and violence"
                      id="read_data_conflict"
                      img={read_data_conflict}
                    />
                  </div>
                  <div className="col-md-6">
                    <ShowModalGlance
                      name="How to read our data - disasters"
                      id="read_data_disasters"
                      img={read_data_disasters}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <YouTubeVideo youtubeId="XlUNZ9shI5w"></YouTubeVideo>
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <YouTubeVideo youtubeId="BHRI-0suJhw"></YouTubeVideo>
                  </div>
                </div>
              </Container>
            </Fade>

            <div id="part1" className="section">
              <Fade>
                <Container maxWidth="lg">
                  <Title
                    h2="Partie 1 : Vue d’ensemble"
                    h3="Déplacements internes en 2021"
                  ></Title>
                  <p>
                    Les conflits, la violence et les catastrophes ont provoqué{" "}
                    <strong>38 millions de déplacements internes</strong> dans
                    141 pays et territoires en 2021, le deuxième chiffre annuel
                    le plus élevé en dix ans après l’année record de 2020
                    concernant les déplacements dus aux catastrophes. Les
                    conflits et la violence ont déclenché 14,4 millions de
                    mouvements, soit une augmentation de près de 50 % par
                    rapport à l’année précédente.
                  </p>

                  {/* <Zoomable
                  src={map_global}
                  alt='Countries and territories with most new displacements in 2021'
                  caption='Countries and territories with most new displacements in 2021'
                  zoom='200'
                  dld='/'
                  interact='Vous pouvez interagir avec cette infographie pour consulter les données détaillées'
                  download='Télécharger l’infographie'
                /> */}
                </Container>
                <Container>
                  <Interactive
                    svg={map_global_svg}
                    png={map_global}
                    id="globalmap"
                    tooltip_id="globaltooltip"
                    dld={map_global_dld}
                    caption="Pays et territoires les plus touchés par les déplacements internes en 2021"
                    alt="Pays et territoires les plus touchés par les déplacements internes en 2021"
                    interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                    download="Télécharger l’infographie"
                    name="Global map"
                    dropdown={[
                      "AFG",
                      "AGO",
                      "AUS",
                      "BGD",
                      "BRA",
                      "BFA",
                      "BDI",
                      "CMR",
                      "CAN",
                      "CAF",
                      "TCD",
                      "CHN",
                      "COL",
                      "CUB",
                      "COD",
                      "SLV",
                      "ETH",
                      "GRC",
                      "HTI",
                      "IND",
                      "IDN",
                      "IRN",
                      "IRQ",
                      "KEN",
                      "KGZ",
                      "MYS",
                      "MLI",
                      "MEX",
                      "MOZ",
                      "MMR",
                      "NPL",
                      "NLD",
                      "NER",
                      "NGA",
                      "PAK",
                      "PSE",
                      "PHL",
                      "SOM",
                      "SSD",
                      "LKA",
                      "VCT",
                      "SDN",
                      "SYR",
                      "TZA",
                      "TUR",
                      "UGA",
                      "USA",
                      "VEN",
                      "VNM",
                      "YEM",
                    ]}
                  />
                </Container>
              </Fade>
              <HeroQuote
                imageUrl={Quote6}
                id="quote-6"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="Une jeune fille résidant actuellement à Tillaberi, au Niger, a pu renouer avec ses camarades de classe et ses pairs après avoir reçu un soutien psychosocial pour l’aider à faire face à ses propres expériences de déplacement. © Avril 2022 "
              ></HeroQuote>
              <Fade>
                <>
                  <Container maxWidth="lg" id="spiral">
                    <Title h4="Les vingt-cinq pays les plus touchés par les déplacements internes"></Title>
                  </Container>{" "}
                  <Container maxWidth="lg">
                    <Interactive
                      svg={Spiral}
                      png={SpiralMobile}
                      id="spiral"
                      tooltip_id="sunbursttooltip"
                      dld={SpiralDld}
                      caption="Vingt-cinq pays et territoires les plus touchés par les déplacements internes en 2021"
                      alt="Vingt-cinq pays et territoires les plus touchés par les déplacements internes en 2021"
                      interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                      download="Télécharger l’infographie"
                      name="Spiral"
                      dropdown={[
                        "AFG",
                        "BFA",
                        "BRA",
                        "CAF",
                        "CHN",
                        "COD",
                        "CUB",
                        "ETH",
                        "HTI",
                        "IDN",
                        "IND",
                        "MLI",
                        "MMR",
                        "MOZ",
                        "NER",
                        "NGA",
                        "PHL",
                        "SDN",
                        "SLV",
                        "SOM",
                        "SSD",
                        "SYR",
                        "USA",
                        "VNM",
                        "YEM",
                      ]}
                    />
                  </Container>
                </>
              </Fade>
              <HeroQuote
                imageUrl={Quote3}
                id="quote-3"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="Des Palestiniens s’abritant sous des tentes qu’ils ont installées au milieu des décombres à Gaza. © Mustafa Hassona / Agence Anadolu via Getty Image, mai 2021."
              ></HeroQuote>
              <Fade>
                <>
                  <Container className="mt-5" maxWidth="lg" id="breakdown">
                    <Title h4="Répartition par conflit et catastrophe"></Title>
                  </Container>{" "}
                  <Container className="showLandscape" maxWidth="lg">
                    <Zoomable
                      src={BreakdownMobile}
                      id="breakdowngraphic"
                      tooltip_id=""
                      dld={BreakddownDld}
                      caption="Répartition des déplacements internes par conflit, violence et catastrophe en 2021"
                      alt="Répartition des déplacements internes par conflit, violence et catastrophe en 2021"
                      interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                      download="Télécharger l’infographie"
                      zoom={200}
                      name="breakdown"
                    />
                  </Container>
                  <Container className="showPortrait" maxWidth="lg">
                    <Zoomable
                      src={BreakdownMobilePortrait}
                      id="breakdownPortrait"
                      tooltip_id=""
                      dld={BreakddownDld}
                      caption="Répartition des déplacements internes par conflit, violence et catastrophe en 2021"
                      alt="Répartition des déplacements internes par conflit, violence et catastrophe en 2021"
                      interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                      download="Télécharger l’infographie"
                      zoom={200}
                      name="breakdown"
                    />
                  </Container>
                </>
              </Fade>
              <HeroQuote
                imageUrl={Quote2}
                id="quote-2"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="Camp de déplacés de Mbela, République centrafricaine. © Tom Peyre-Costa / NRC, février 2021."
              ></HeroQuote>
              <Fade>
                <Container className="mt-5" id="people-living-in-displacement">
                  <Title h4="Personnes vivant en situation de déplacement"></Title>
                  <p>
                    Fin 2021, il y avait <strong>59,1 millions</strong> de
                    personnes déplacées à l’intérieur de leur propre pays à
                    travers le monde, dont{" "}
                    <span className="orange">53,2 millions</span> à la suite de
                    conflits et de violences et{" "}
                    <span className="blue">5,9 millions</span> à la suite de
                    catastrophes.
                  </p>
                </Container>
                {/* <Container className='mt-5'>
                  <h4>Conflict</h4>
                </Container>
                <Container >
                  <Interactive
                    svg={map_conflict_svg}
                    png={map_conflict}
                    id='idpconflict'
                    tooltip_id='conflicttooltip'
                    dld={map_conflict_dld}
                    caption='Total number of IDPs by conflict and violence as of 31 December 2021'
                    alt='Total number of IDPs by conflict and violence as of 31 December 2021'
                    interact='Vous pouvez interagir avec cette infographie pour consulter les données détaillées'
                    download='Télécharger l’infographie'
                    name='Map - conflict'
                    dropdown={[
                      "AFG",
                      "BFA",
                      "COD",
                      "COL",
                      "ETH",
                      "NGA",
                      "SDN",
                      "SOM",
                      "SYR",
                      "YEM"
                      ]}
                  />
                </Container>
                <Container className='mt-5'>
                  <h4>Disasters</h4>
                </Container>
                <Container className='mb-5'>
                  <Interactive
                    svg={map_disasters_svg}
                    png={map_disasters}
                    id='idpdisasters'
                    tooltip_id='disasterstooltip'
                    dld={map_disasters_dld}
                    caption='People internally displaced by disasters as of 31 December 2021'
                    alt='People internally displaced by disasters as of 31 December 2021'
                    interact='Vous pouvez interagir avec cette infographie pour consulter les données détaillées'
                    download='Télécharger l’infographie'
                    name='Map - disasters'
                    dropdown={[
                      "AFG",
                      "CHN",
                      "COD",
                      "ETH",
                      "HTI",
                      "IDN",
                      "MOZ",
                      "NGA",
                      "PHL",
                      "SSD"
                      ]}
                  /> */}
                <Container className="mb-5" id="tabs">
                  <Tabs>
                    <TabList>
                      <Tab>Conflits et violences </Tab>
                      <Tab>Catastrophes </Tab>
                    </TabList>
                    <TabPanel>
                      <Interactive
                        svg={map_conflict_svg}
                        png={map_conflict}
                        id="idpconflict"
                        tooltip_id="conflicttooltip"
                        dld={map_conflict_dld}
                        caption="Nombre total de PDI à la suite de conflits et violences au 31 décembre 2021"
                        alt="Nombre total de PDI à la suite de conflits et violences au 31 décembre 2021"
                        interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                        download="Télécharger l’infographie"
                        name="Map - conflict"
                        dropdown={[
                          "AFG",
                          "BFA",
                          "COD",
                          "COL",
                          "ETH",
                          "NGA",
                          "SDN",
                          "SOM",
                          "SYR",
                          "YEM",
                        ]}
                      />
                    </TabPanel>
                    <TabPanel>
                      <Interactive
                        svg={map_disasters_svg}
                        png={map_disasters}
                        id="idpdisasters"
                        tooltip_id="disasterstooltip"
                        dld={map_disasters_dld}
                        caption="Nombre total de PDI à la suite de catastrophes au 31 décembre 2021"
                        alt="Nombre total de PDI à la suite de catastrophes au 31 décembre 2021"
                        interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                        download="Télécharger l’infographie"
                        name="Map - disasters"
                        dropdown={[
                          "AFG",
                          "CHN",
                          "COD",
                          "ETH",
                          "HTI",
                          "IDN",
                          "MOZ",
                          "NGA",
                          "PHL",
                          "SSD",
                        ]}
                      />
                    </TabPanel>
                  </Tabs>
                </Container>
              </Fade>
              {/* <Fade>
              <Container className='mt-5' maxWidth='md' id='impacts'>
                <Title h4='The economic and social impacts of displacement'></Title>
                <p>
                  We estimate that the economic impact of internal displacement
                  worldwide was more than $21 billion in 2021. The figure
                  includes the cost of providing every IDP with support for
                  their housing, education, health and security, and accounts
                  for their loss of income for one year of displacement. It is
                  based on information published in humanitarian response plans
                  and only considers the cost of covering IDPs’ basic needs and
                  immediate losses.
                </p>
                <p>
                  It does not include the economic impacts of displacement on
                  host communities or IDPs in the process of returning. Nor does
                  it account for investments made by governments or development
                  stakeholders to address the longer-term consequences of
                  displacement. Put simply, when it comes to understanding the
                  financial burden of the phenomenon, the figure is just the tip
                  of the iceberg.
                </p>
                <YouTubeVideo youtubeId='KcgYNEpuUV4' />
              </Container>
            </Fade>
            <Fade>
              <Container maxWidth='md' id='age'>
                <Title h4='Breakdown of IDPs by age group'></Title>
                <Zoomable
                  src={Age}
                  alt='Estimated number of people of different age groups living in internal displacement as a result of conflict, violence and disasters globally at the end of 2021'
                  caption='Estimated number of people of different age groups living in internal displacement as a result of conflict, violence and disasters globally at the end of 2021'
                  zoom='200'
                  dld='/'
                  interact='Vous pouvez interagir avec cette infographie pour consulter les données détaillées'
                  download='Télécharger l’infographie'
                />
              </Container>
            </Fade> */}

              <HeroQuote
                imageUrl={Quote4}
                id="quote-4"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="Le typhon Rai a provoqué le plus grand nombre de déplacements dus à des catastrophes en 2021. Sur la photo, un garçon assis dans les décombres de sa maison détruite. © UNICEF / UN0570020 / Hogsholt, décembre 2021. "
              ></HeroQuote>

              <Container maxWidth="lg" id="regional-overviews">
                <Title h4="Aperçus régionaux"></Title>
                <p>
                  L’Afrique subsaharienne représentait plus de 80 % de tous les
                  déplacements internes déclenchés par les conflits et la
                  violence dans le monde en 2021. Le total régional était
                  supérieur de 4,7 millions au chiffre de l’année précédente,
                  principalement en raison des conflits en Éthiopie, en
                  République démocratique du Congo (RDC), au Burkina Faso, en
                  Somalie et en République centrafricaine (RCA).
                </p>
                <p>
                  La plupart des déplacements nouveaux et répétés provoqués par
                  des catastrophes en 2021 ont été enregistrés dans les régions
                  Asie et Pacifique, qui comptabilisaient environ 80 % du total.
                  Les cyclones tropicaux, les pluies de mousson et les
                  inondations frappent des zones très exposées qui abritent des
                  millions de personnes. Les pays les plus touchés ont été la
                  Chine, les Philippines et l’Inde.
                </p>

                <Region
                  Json={JSONData}
                  regionId="ssa"
                  svg={globe_ssa}
                  hidden={[
                    "Les catastrophes ont provoqué 2,6 millions de déplacements, soit moins qu’en 2020. Les inondations ont été moins intenses et moins étendues, représentant ainsi environ 60 % du total, contre 98 % l’année précédente. L’activité volcanique, la sécheresse, les tempêtes, les tremblements de terre et les incendies de forêt ont représenté les 40 % restants. Certaines catastrophes ont déplacé des personnes dans des zones déjà confrontées aux effets des conflits et de la violence, et ces crises cumulées ont plongé des millions de personnes dans une insécurité alimentaire aiguë. De nombreux pays ont enregistré les pires niveaux jamais atteints, y compris des cas de famine.",
                    "À la fin de l’année, 27,2 millions de personnes vivaient en situation de déplacement interne dans l’ensemble de la région à la suite de conflits, de violences et de catastrophes, soit une augmentation de 3,1 millions par rapport au chiffre de 2020. Dans plusieurs pays, des PDI ont subi des attaques ayant contraint certaines d’entre elles à fuir à nouveau, avec pour conséquence d’accroître leur vulnérabilité et d’entraver l’accès humanitaire. Ces tendances préoccupantes rappellent la nécessité urgente d’intensifier les efforts pour faire face et réduire les déplacements internes dans la région.",
                    "Un certain nombre de pays ont adopté des pratiques prometteuses. Il s’agit notamment de l’évacuation vitale des personnes avant la survenue d’une catastrophe et d’un meilleur suivi de la durée du déplacement dans le but d’intervenir de manière plus adaptée auprès des personnes touchées. Des opérations de retour dirigées par les pouvoirs publics ont également eu lieu dans au moins cinq pays. Ces évolutions positives se heurtent toutefois à un certain nombre de difficultés.",
                  ]}
                >
                  <p>
                    Les conflits et la violence ont provoqué 11,6 millions de
                    déplacements internes en Afrique subsaharienne en 2021, le
                    chiffre le plus élevé jamais enregistré pour la région. De
                    nouvelles vagues de violence en Afrique de l’Est et
                    l’escalade des tensions et conflits dans les régions du
                    Sahel central et du lac Tchad ont été à l’origine de la
                    plupart des mouvements, mais la violence a également
                    entraîné des déplacements en Afrique australe et centrale,
                    notamment en RCA, en RDC et au Mozambique. L’activité
                    militaire étrangère a également influencé les tendances de
                    déplacement et de retour dans un certain nombre de pays.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="mena"
                  svg={globe_mena}
                  hidden={[
                    "Les catastrophes ont également provoqué un nombre plus faible de déplacements internes en 2021, soit 233 000, le chiffre le plus bas depuis 2018. Les inondations ont représenté la plupart d’entre elles, soit 178 000, suivies des tremblements de terre et des tempêtes. La tendance à la baisse des chiffres doit cependant être interprétée avec prudence. La région a été touchée par une grave sécheresse, au cours de l’année, qui a provoqué une pénurie d’eau et des incendies de forêt, de l’Algérie à l’Iran, mais aucun pays n’ayant systématiquement surveillé les déplacements y afférents, les chiffres globaux doivent être interprétés avec prudence. À la fin de l’année, environ 49 000 personnes vivaient en situation de déplacement à la suite de catastrophes dans la région.",
                  ]}
                >
                  <p>
                    Les conflits et la violence ont provoqué un million de
                    déplacements internes au Moyen-Orient et en Afrique du Nord
                    (MENA) en 2021, soit moins de la moitié des 2,1 millions
                    enregistrés l’année précédente et le chiffre le plus bas
                    pour la région depuis une décennie. Cette baisse est
                    essentiellement due à la désescalade des conflits en Irak,
                    en Libye et en Syrie. Dans ces pays, l’instabilité a
                    néanmoins continué de régner et la violence s’est accrue au
                    Yémen. Le conflit a également repris à Gaza, en mai,
                    provoquant ainsi plus de 117 000 déplacements, et la
                    violence a entraîné des déplacements à petite échelle au
                    Liban et en Israël. Dans l’ensemble de la région, le nombre
                    de personnes déplacées à la fin de l’année à la suite de
                    conflits et de violences est resté largement inchangé par
                    rapport à 2020, soit 12,3 millions.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="eap"
                  svg={globe_eap}
                  hidden={[
                    "Les effets de La Niña se sont manifestés dans différents pays pour la deuxième année consécutive. Les tempêtes ont frappé le Pacifique Sud et l’Asie de l’Est et du Sud-Est, déclenchant ainsi plus de huit millions de déplacements, la grande majorité sous forme d’évacuations préventives. Les inondations en ont provoqué environ 5,3 millions. Les inondations ont été particulièrement intenses en Chine, où un événement survenu en juillet dans le Henan a provoqué environ 1,5 million de déplacements.",
                    "Les conflits et les violences ont entraîné 626 000 déplacements internes dans la région, soit trois fois le chiffre de 2020 et le plus élevé depuis 2017. Cela était principalement dû à l’escalade du conflit au Myanmar, en particulier après le coup d’État militaire de février. Environ 448 000 déplacements ont été recensés, le chiffre le plus élevé jamais enregistré pour le pays, bien qu’il s’agisse d’une estimation prudente. Le conflit s’est également superposé à des catastrophes, aggravant ainsi davantage la situation humanitaire. À la fin de l’année, environ 2,8 millions de personnes vivaient en situation de déplacement interne en Asie de l’Est et dans le Pacifique, dont 896 000 à la suite de conflits et de violences.",
                  ]}
                >
                  <p>
                    En 2021, les catastrophes ont provoqué 13,7 millions de
                    déplacements internes en Asie de l’Est et dans le Pacifique,
                    le chiffre le plus élevé depuis 2016 et supérieur à la
                    moyenne annuelle de 11,6 millions de la dernière décennie.
                    Comme les années précédentes, la région a été à l’origine de
                    la majorité des déplacements dus aux catastrophes
                    enregistrés dans le monde. Elle abrite la majeure partie de
                    la population mondiale, dont beaucoup vivent dans des zones
                    sujettes à une multitude de dangers, notamment les tempêtes,
                    les inondations, les tremblements de terre et les éruptions
                    volcaniques.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="sa"
                  svg={globe_sa}
                  hidden={[
                    "Les conflits et la violence ont également entraîné plus de 736 000 déplacements, dont la grande majorité en Afghanistan. Alors que les troupes des États-Unis et de l’OTAN amorçaient leur retrait définitif et que les talibans affrontaient les forces gouvernementales, l’insécurité et la détérioration des conditions humanitaires déclenchaient 723 000 déplacements, le chiffre le plus élevé jamais enregistré pour le pays.",
                    "À la fin de l’année, environ 6,9 millions de personnes vivaient en situation de déplacement interne dans la région, 5,4 millions à la suite de conflits et de violences et 1,5 million à la suite de catastrophes.",
                  ]}
                >
                  <p>
                    Les catastrophes déclenchent la plupart des déplacements
                    internes qui ont lieu chaque année en Asie du Sud, et 2021
                    n’a pas fait exception à la règle. Près de 5,3 millions de
                    déplacements dus à des catastrophes ont été enregistrés, au
                    cours de l’année, un chiffre relativement élevé à l’échelle
                    mondiale, mais inférieur à la moyenne décennale de 6,2
                    millions de la région. La baisse résultait en partie d’une
                    saison de mousson de moindre ampleur.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="am"
                  svg={globe_am}
                  hidden={[
                    "Les conflits et la violence ont provoqué 381 000 déplacements, principalement en Colombie et en Amérique centrale, et une recrudescence de la violence criminelle a conduit au chiffre le plus élevé jamais enregistré pour Haïti. Pour la première fois, nous avons également obtenu des données sur les déplacements dus à la violence au Brésil, mais, ici comme ailleurs dans la région, il est peu probable que les informations compilées reflètent pleinement la réalité, car dans de nombreux pays, ce type de déplacement n’est pas systématiquement recensé.",
                  ]}
                >
                  <p>
                    Les catastrophes ont été le principal déclencheur des
                    déplacements internes en Amérique, en 2021, représentant
                    ainsi près de 1,7 million, dont plus de la moitié due à des
                    tempêtes et des inondations. La région a également été
                    fortement touchée par les incendies de forêt et les risques
                    géophysiques. La disponibilité et l’accessibilité des
                    données varient considérablement d’un pays à l’autre, ce qui
                    joue un rôle dans les tendances discutées ci-dessous. Les
                    catastrophes à petite échelle ne sont généralement pas
                    signalées, mais elles ne doivent pas être ignorées, compte
                    tenu de leurs effets sur les communautés locales, notamment
                    en Amérique latine et dans les Caraïbes.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="eca"
                  svg={globe_eca}
                  hidden={[
                    "La violence a provoqué au moins 61 000 déplacements internes, le chiffre le plus élevé pour la région depuis 2016. Deux jours d’affrontements frontaliers entre le Kirghizistan et le Tadjikistan en ont représenté 56 000, soit un peu plus de 90 % du total. Un nombre très faible de déplacements a été enregistré en Ukraine, en 2021, mais l’offensive militaire russe de février 2022 a conduit le pays à subir la situation de déplacement interne la plus importante et la plus évolutive au monde.",
                  ]}
                >
                  <p>
                    Les catastrophes ont provoqué 276 000 déplacements internes
                    en Europe et en Asie centrale en 2021. Les plus importantes
                    comprenaient des incendies de forêt, en Méditerranée, des
                    tempêtes et des inondations, en Europe occidentale et
                    centrale, et une éruption volcanique dans les îles Canaries
                    espagnoles.
                  </p>
                </Region>
              </Container>
              {/* <Fade bottom>
              <Container
                className='p-3 mt-5'
                maxWidth={false}
                style={{ backgroundColor: '#dee2e6' }}
              >
                <Container
                  maxWidth='md'
                  id='covid19'
                  className='border p-3 my-5'
                >
                  <Title
                    h3='Special feature'
                    h4='COVID-19: an added burden on the precarious lives of IDPs'
                  ></Title>
                  <div className='row'>
                    <div className='col-md-7'>
                      <p>
                        Covid-19 continued to affect people and economies across
                        the world in 2021 and had negative impacts on IDPs’
                        lives. Comprehensive data is lacking, but several
                        studies and programme insights confirm that the pandemic
                        was uniquely threatening to people on the move. Rather
                        than acting as a leveller, it has aggravated structural
                        inequities and vulnerabilities.
                      </p>
                      <p>
                        It tends to be difficult to disentangle cause and effect
                        and identify whether the pandemic caused, prolonged or
                        worsened a particular crisis. Coming at a time when the
                        world has more IDPs than ever before, however, it has
                        without question made the lives of millions on the move
                        even more precarious. As countries continued lockdown
                        measures and other restrictions to fight the spread of
                        the virus, IDPs felt the consequences on their income,
                        food security, basic services and ability to return to
                        their homes or move onwards to safe havens.
                      </p>
                    </div>
                    <div className='col-md-5'>
                      <img
                        src={img_specialfeature}
                        alt='Young boy wearing a mask'
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>

                  <p>
                    <DownloadPub name='covid' suffix='Download'></DownloadPub>
                  </p>
                </Container>
              </Container>
            </Fade> */}

              <Container maxWidth="lg">
                <p>
                  <DownloadPub name="part1" suffix="Télécharger" />
                </p>
              </Container>
              <HeroQuote
                imageUrl={Quote1}
                id="quote-1"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0.3"
                copyright="Une petite fille fait un dessin depuis l’intérieur d’un camp pour personnes déplacées dans le nord de l’Irak. © Beate Simarud / NRC, octobre 2021. "
              >
                <p className="large text-center">
                  « Les enfants et les jeunes sont des agents du changement. Les
                  reconnaître en tant que tels est essentiel pour protéger les
                  acquis du développement et réduire le risque d’augmentations
                  futures. Préparer le monde de demain doit commencer par leur
                  participation active et leur leadership. »
                </p>
                <p>Alexandra Bilak, Director, IDMC</p>
              </HeroQuote>
            </div>
            <>
              <Fade>
                <Container maxWidth="lg" className="section" id="part2">
                  <Title
                    h2="Partie 2"
                    h3="Enfants et jeunes en situation de déplacement interne"
                  ></Title>
                  <p>
                    Environ 25,2 millions de PDI dans le monde ont moins de 18
                    ans et les effets de leur déplacement vont bien au-delà de
                    leurs besoins immédiats de sécurité, de bien-être et
                    d’éducation. Un enfant en bonne santé et heureux a plus de
                    chance de contribuer à une société équitable et à une
                    économie qui fonctionne.
                  </p>
                  <p>
                    Pour mieux comprendre ces effets plus larges et à plus long
                    terme, il faut disposer de davantage de données, mais il est
                    clair que protéger et soutenir les enfants et les jeunes
                    déplacés permet non seulement de garantir leurs droits, mais
                    contribue également à un avenir plus stable pour tous.
                  </p>
                </Container>
                <Container>
                  <Interactive
                    svg={map_youth_svg}
                    png={map_youth}
                    id="idpyouth"
                    tooltip_id="youthtooltip"
                    dld={map_youth_dld}
                    caption="Nombre total d’enfants en situation de déplacement interne à la suite de conflits, de violences et de catastrophes au 31 décembre 2021"
                    alt="Nombre total d’enfants en situation de déplacement interne à la suite de conflits, de violences et de catastrophes au 31 décembre 2021"
                    interact="Vous pouvez interagir avec cette infographie pour consulter les données détaillées"
                    download="Télécharger l’infographie"
                    name="Map - youth"
                    dropdown={[
                      "AFG",
                      "COD",
                      "COL",
                      "ETH",
                      "NGA",
                      "SDN",
                      "SOM",
                      "SSD",
                      "SYR",
                      "YEM",
                    ]}
                  />
                </Container>
                <Container maxWidth="lg">
                  {/* <Title h4='Key Messages:' />
                <ul>
                  <li>
                    Of the nearly 60 million internally displaced people (IDPs),
                    25.2 million are children under the age of 18.
                  </li>
                  <li>
                    Protecting them from abuse and supporting their health,
                    wellbeing and education not only safeguards their rights,
                    but also contributes to a more stable future for all.
                  </li>
                  <li>
                    Displacement’s impacts on children and youth are not felt
                    equally, and they vary by individual, family and community.
                    Neither are they felt only locally or in the moment, they
                    have wider repercussions for years to come.
                  </li>
                </ul> */}
                  <p>
                    <DownloadPub name="part2" suffix="Télécharger" />
                  </p>
                  <Title h4="Conclusion" />
                  <p>
                    Le nombre de personnes vivant en situation de déplacement
                    interne dans le monde a atteint un niveau record. Les
                    chiffres sans précédent présentés dans ce rapport sont
                    alimentés par des conflits à la fois nouveaux et prolongés,
                    en particulier en Afrique et au Moyen-Orient. Des millions
                    d’autres ont fui leurs foyers, en Europe, ces derniers mois,
                    alors que la guerre en Ukraine est en passe de devenir la
                    plus grande crise de déplacement au monde. Les déplacements
                    liés aux catastrophes continuent de représenter un défi
                    mondial important dont les effets se font sentir aux quatre
                    coins de la planète.
                  </p>
                  <p>
                    Derrière les données se cachent des millions de vies
                    bouleversées, de communautés déchirées et d’enfants privés
                    d’avenir. Les effets du déplacement pèsent non seulement sur
                    les enfants d’aujourd’hui, mais aussi sur les générations
                    futures. Nous devons regarder au-delà des conséquences
                    directes et immédiates sur les jeunes pour mieux comprendre
                    leurs liens avec des impacts à plus long terme sur les
                    communautés et les sociétés. En attendant, pour protéger les
                    acquis du développement et réduire le risque de déplacement
                    futur, il est essentiel de reconnaître les enfants et les
                    jeunes comme des agents du changement.
                  </p>
                  <p>
                    <DownloadPub name="conclusion" suffix="Télécharger la" />
                  </p>
                </Container>
              </Fade>
              {/* <HeroQuote
                imageUrl={Quote5}
                id='quote-5'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0'
                copyright='The owner of the house closest to the Cumbre Vieja Volcano that erupted in La Palma, Canary Islands, Spain in February cleans up the surroundings of his house. © Kike Rincon/Europa Press via Getty Images, February 2022.'
              ></HeroQuote> */}
            </>
            <HeroVideos
              imageUrl={Quote7}
              id="quote-7"
              txtColor="#ffffff"
              bgColor="#0a3758"
              bgOpacity="0.8"
              copyright=""
            >
              <Container>
                <Title h4="In their own words"></Title>
                <div className=" row">
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="v4skVdMYBEE" />
                    <p style={{ color: "#ffffff" }}>
                      Jan Egeland, Secretary general, NRC
                    </p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="Qj6qmxbci9I" />
                    <p style={{ color: "#ffffff" }}>Christelle Cazabat, IDMC</p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="q3p80WzGero" />
                    <p style={{ color: "#ffffff" }}>
                      Farishta Afzaly, Youth advocate
                    </p>
                  </div>
                </div>
              </Container>
            </HeroVideos>
            <>
              <Container id="download" maxWidth="lg" className="my-3">
                <Title h4="Téléchargements"></Title>
                <div className="row">
                  <div className="col-md-6">
                    <Fade left>
                      <img src={cover3d} alt="GRID2022 cover" />
                    </Fade>
                  </div>
                  <div className="col-md-6">
                    <Fade right>
                      <p>
                        <DownloadPub name="fullreport"></DownloadPub>
                      </p>
                      <p>
                        <DownloadPub name="fullreporthigh"></DownloadPub>
                      </p>
                      <div className="border p-3 mb-5">
                        <p>ou sélectionner une section</p>
                        <SelectReport
                          options={[
                            {
                              label: `${PubData["foreword"][0]}`,
                              value: "foreword",
                            },
                            {
                              label: "----------------------",
                              value: "",
                              isDisabled: true,
                            },
                            {
                              label: `${PubData["part1"][0]}`,
                              value: "part1",
                            },
                            {
                              label: "----------------------",
                              value: "",
                              isDisabled: true,
                            },
                            {
                              label: "Aperçus régionaux",
                              options: [
                                {
                                  label: `${PubData["ssa"][0]}`,
                                  value: "ssa",
                                },
                                {
                                  label: `${PubData["mena"][0]}`,
                                  value: "mena",
                                },
                                {
                                  label: `${PubData["eap"][0]}`,
                                  value: "eap",
                                },
                                {
                                  label: `${PubData["sa"][0]}`,
                                  value: "sa",
                                },
                                {
                                  label: `${PubData["am"][0]}`,
                                  value: "am",
                                },
                                {
                                  label: `${PubData["eca"][0]}`,
                                  value: "eca",
                                },
                              ],
                            },
                            {
                              label: "En détail",
                              options: [
                                {
                                  label: `${PubData["ssa-eth"][0]}`,
                                  value: "ssa-eth",
                                },
                                {
                                  label: `${PubData["ssa-sdn"][0]}`,
                                  value: "ssa-sdn",
                                },
                                {
                                  label: `${PubData["mena-pal"][0]}`,
                                  value: "mena-pal",
                                },
                                {
                                  label: `${PubData["eap-chn"][0]}`,
                                  value: "eap-chn",
                                },
                                {
                                  label: `${PubData["eap-mmr"][0]}`,
                                  value: "eap-mmr",
                                },
                                {
                                  label: `${PubData["eap-png"][0]}`,
                                  value: "eap-png",
                                },
                                {
                                  label: `${PubData["sa-afg"][0]}`,
                                  value: "sa-afg",
                                },
                                {
                                  label: `${PubData["am-hai"][0]}`,
                                  value: "am-hai",
                                },
                                {
                                  label: `${PubData["eca-ca"][0]}`,
                                  value: "eca-ca",
                                },
                                {
                                  label: `${PubData["eca-wa"][0]}`,
                                  value: "eca-wa",
                                }
                              ],
                            },
                            {
                              label: "----------------------",
                              value: "",
                              isDisabled: true,
                            },
                            {
                              label: `${PubData["part2"][0]}`,
                              value: "part2",
                            },
                            {
                              label: `${PubData["conclusion"][0]}`,
                              value: "conclusion",
                            },
                            {
                              label: `${PubData["figures"][0]}`,
                              value: "figures",
                            },
                          ]}
                          action="Voir"
                        ></SelectReport>
                      </div>
                      <>
                        <div className="border p-3 mb-5">
                          <p>Documents d’information</p>
                          <SelectReport
                            options={[
                              {
                                label: `${PubData["bg-unesco-iiep"][0]}`,
                                value: "bg-unesco-iiep",
                              },
                              {
                                label: `${PubData["bg-save-1"][0]}`,
                                value: "bg-save-1",
                              },
                              {
                                label: `${PubData["bg-save-2"][0]}`,
                                value: "bg-save-2",
                              },
                              {
                                label: `${PubData["bg-plan-int"][0]}`,
                                value: "bg-plan-int",
                              },
                              {
                                label: `${PubData["bg-jips"][0]}`,
                                value: "bg-jips",
                              },
                              {
                                label: `${PubData["bg-iom-unicef"][0]}`,
                                value: "bg-iom-unicef",
                              },
                              {
                                label: `${PubData["bg-impact"][0]}`,
                                value: "bg-impact",
                              },
                            ]}
                            action="Télécharger"
                          ></SelectReport>
                        </div>
                      </>
                      <>
                        <p>
                          Chiffres par pays{" "}
                          <Tooltip title="Information on the sources of our figures, as well as methodologies and caveats for some of the countries most affected by internal displacement. For any additional information contact us at info@idmc.ch">
                            <InfoOutlinedIcon></InfoOutlinedIcon>
                          </Tooltip>{" "}
                        </p>
                        <SelectReport
                          options={countrylistoptions}
                          action="Télécharger l’analyse des chiffres du conflit pour"
                        ></SelectReport>
                      </>
                    </Fade>
                  </div>
                </div>
              </Container>
            </>
            <HeroVideos
              imageUrl={Quote8}
              id="quote-8"
              txtColor="#ffffff"
              bgColor="#0a3758"
              bgOpacity="0.8"
              copyright=""
            >
              <Container>
                <Title h4="Launch of GRID 2022"></Title>
                <div className=" row">
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="Dtim9Jbt_M0" />
                    <p style={{ color: "#ffffff" }}>
                      Launch of GRID 2022: high-level segment
                    </p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="i0YBwn8XgMY" />
                    <p style={{ color: "#ffffff" }}>
                      Launch of GRID 2022: technical segment
                    </p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="BlOm0h7i_jI" />
                    <p style={{ color: "#ffffff" }}>
                      Launch of GRID 2022: technical segment
                    </p>
                  </div>
                </div>
              </Container>
            </HeroVideos>
            <Container
              maxWidth={false}
              className="py-3"
              style={{ backgroundColor: "#dee2e6" }}
            >
              <Container id="mediapack" maxWidth="lg" className="my-3">
                <Title h4="Dossier média"></Title>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Télécharger le communiqué de presse</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>
                      {" "}
                      <PictureAsPdfIconOutlined>
                        {" "}
                      </PictureAsPdfIconOutlined>{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_ARA.pdf
"
                      >
                        Arabe
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_EN.pdf
"
                      >
                        Anglais
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_FR.pdf
"
                      >
                        Français
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_DE.pdf
"
                      >
                        Allemand
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_NOR.pdf
"
                      >
                        Norvégien
                      </a>{" "}|{' '}
<a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_Russian.pdf
'>Russian</a> 
                      {" "}|{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_ES.pdf
"
                      >
                        Espagnol
                      </a>{" "}
                      |{" "}
                      <a href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_SWE.pdf">
                        Suédois
                      </a>
                    </p>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography>Biographie des porte-parole</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="row">
                      <div className="col-md-4">
                        <ShowModal
                          img={Alexandra}
                          name="Alexandra Bilak"
                          title="Directrice du Centre de surveillance des déplacements internes"
                        >
                          <p>
                            Alexandra Bilak affiche près de 20 ans d’expérience
                            dans le secteur international à but non lucratif,
                            plus particulièrement en ce qui concerne la
                            recherche et l’élaboration de politiques sur le
                            déplacement dans le contexte des conflits armés, de
                            la violence, des catastrophes et du changement
                            climatique. En 2014, elle a rejoint le Centre de
                            surveillance des déplacements internes (IDMC), à
                            Genève, en qualité de responsable des politiques et
                            de la recherche, où elle a dirigé la première
                            publication du rapport phare de l’IDMC, le Rapport
                            mondial sur le déplacement interne (GRID), dont elle
                            est devenue directrice en août 2016.
                          </p>
                          <p>
                            Avant de rejoindre l’IDMC, Alexandra a passé une
                            décennie à travailler en Afrique subsaharienne pour
                            des ONG internationales et des instituts de
                            recherche, notamment Oxfam, le Life & Peace
                            Institute, l’International Rescue Committee et le
                            Danish Refugee Council. Elle a vécu et travaillé au
                            Rwanda, en 2001, en République démocratique du
                            Congo, de 2004 à 2008, et au Kenya, de 2009 à 2014.
                            Elle a publié de nombreux articles sur les thèmes du
                            déplacement forcé, des conflits et du développement
                            de la société civile.
                          </p>
                          <p>
                            Alexandra est titulaire d’une maîtrise en politique
                            internationale de la School of Oriental and African
                            Studies de Londres et d’un DEA (diplôme d’études
                            approfondies) en études africaines et sciences
                            politiques de l’université Paris I
                            Panthéon-Sorbonne. Elle est bilingue
                            français-anglais.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Jan}
                          name="Jan Engeland"
                          title="Secrétaire général du Conseil norvégien pour les réfugiés"
                          id="jan"
                        >
                          <p>
                            Jan Egeland est secrétaire général du Conseil
                            norvégien pour les réfugiés (NRC). En septembre
                            2015, il a été nommé conseiller spécial de l’envoyé
                            spécial des Nations unies pour la Syrie par le
                            secrétaire général des Nations unies, une mission
                            tout particulièrement axée sur l’accès humanitaire
                            et la protection des civils. Il a mis fin à ce rôle
                            en décembre 2018.
                          </p>
                          <p>
                            De 2003 à 2006, Jan Egeland a été sous-secrétaire
                            général des Nations unies aux affaires humanitaires
                            et coordinateur des secours d’urgence. Avant de
                            prendre ses fonctions au NRC en 2013, il a occupé le
                            poste de directeur pour l’Europe de Human Rights
                            Watch (2011-2013) et, avant cela, celui de directeur
                            exécutif de l’Institut norvégien des affaires
                            internationales (2007-2011).
                          </p>
                          <p>
                            Il a également été conseiller spécial du secrétaire
                            général des Nations unies pour la Colombie
                            (1999-2001) et secrétaire d’État au ministère
                            norvégien des Affaires étrangères (1990-1997). En
                            2006, le magazine Time a désigné Jan Egeland comme
                            l’une des « 100 personnes les plus influentes au
                            monde ».
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Bina}
                          name="Bina Desai"
                          title="Responsable des politiques et de la recherche à l’IDMC  "
                          id="bina"
                        >
                          <p>
                            Bina possède une vaste expérience en matière de
                            programmes et de recherche sur le développement
                            socio-économique dans les pays à faible revenu.
                            Ayant précédemment travaillé au Bangladesh, au
                            Ghana, au Honduras, en Inde, au Kenya, au Malawi, au
                            Mozambique et aux Philippines, ses domaines de
                            recherche englobent les causes structurelles des
                            crises, les impacts économiques et de développement
                            des catastrophes et des conflits, les déplacements
                            internes et les migrations forcées.
                          </p>

                          <p>
                            Elle a travaillé pour le ministère allemand du
                            Développement, le réseau Aga Khan de développement,
                            Christian Aid et le Bureau des Nations unies pour la
                            réduction des risques de catastrophe (UNISDR).
                          </p>
                          <p>
                            En 2017, Bina a rejoint l’IDMC en qualité de
                            responsable des politiques et de la recherche, où
                            elle dirige l’équipe de conseillers principaux et de
                            chercheurs de l’IDMC chargée de l’analyse des
                            politiques et de la collecte de données factuelles
                            liées au déplacement. Bina est titulaire d’une
                            maîtrise en économie et sociologie de l’université
                            de Bielefeld et d’un doctorat en anthropologie
                            sociale de la School of Oriental and African Studies
                            de Londres.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Vicente}
                          name="Vicente Anzellini"
                          title="Coordinateur GRID à l’IDMC "
                          id="vicente"
                        >
                          <p>
                            Vicente dirige l’équipe d’analyse mondiale et
                            régionale de l’IDMC et coordonne la production du
                            Rapport mondial sur le déplacement interne (GRID),
                            travaillant ainsi en étroite collaboration avec tous
                            les départements pour l’élaboration du rapport phare
                            de l’IDMC sur le déplacement interne.
                          </p>

                          <p>
                            Auparavant, il travaillait à l’UNISDR, où il a
                            participé à un exercice d’examen des politiques
                            mondiales qui a servi de base aux indicateurs de
                            politique nationale pour le Cadre de Sendai ainsi
                            qu’à la coordination de la recherche et des
                            programmes nationaux, au développement de données et
                            d’analyses sur les pertes et dommages causés par les
                            catastrophes et au renforcement des capacités
                            gouvernementales en matière de connaissance des
                            risques aux niveaux national et régional. Il a
                            travaillé dans plusieurs pays d’Afrique, d’Asie
                            centrale et du Sud et du Pacifique.
                          </p>

                          <p>
                            Vicente est titulaire d’une licence en histoire et
                            géographie de l’université de Los Andes (Bogotá,
                            Colombie) et d’une maîtrise en géographie humaine et
                            études des migrations de l’université de Neuchâtel
                            (Suisse). Il parle espagnol, français et anglais.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Vincent}
                          name="Vincent Fung"
                          title="Coordinateur régional, Asie et Pacifique"
                          id="vincent"
                        >
                          <p>
                            Vincent est coordinateur régional à l’IDMC, il se
                            concentre sur le suivi et la recherche en matière de
                            déplacement dans la région Asie-Pacifique. Vincent a
                            rejoint l’IDMC en 2016 en qualité d’expert en suivi
                            pour le service des données et des analyses.
                          </p>

                          <p>
                            Fort de plus de 15 ans d’expérience dans le conseil
                            en analyse de données, gestion de l’information et
                            communications visuelles, Vincent s’est penché sur
                            des questions allant de la santé publique aux
                            problèmes urbains, en passant par l’intervention
                            humanitaire et la réduction des risques de
                            catastrophe. Il a été grand maître des données et
                            des communications numériques, formateur et
                            concepteur pour l’ONU, en Suisse, a exercé les
                            fonctions de conseiller en gestion de l’information
                            auprès du coordinateur humanitaire au Timor-Leste et
                            a également fourni une expertise en analyse spatiale
                            et en cartographie pour l’UNOCHA dans la région Asie
                            et Pacifique. Vincent a également apporté son
                            éclairage sur des projets similaires pour le PNUD en
                            Asie du Sud-Est, des ONG de santé dans les Balkans
                            et des gouvernements locaux et fédéraux au Canada.
                          </p>

                          <p>
                            Vincent est géographe et titulaire d’une maîtrise en
                            gestion urbaine et environnementale internationale
                            de l’université RMIT avec spécialisation en études
                            comportementales. Il parle anglais, français et
                            cantonais et possède des connaissances de base en
                            japonais et en thaï.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Ivana}
                          name="Ivana Hajzmanova"
                          title="Coordinatrice régionale, MENA et Afrique subsaharienne"
                          id="ivana"
                        >
                          <p>
                            Ivana est coordinatrice régionale à l’IDMC, elle se
                            concentre sur le suivi et la recherche en matière de
                            déplacement au Moyen-Orient et en Afrique. Elle a
                            rejoint l’IDMC en 2016, apportant ainsi son
                            expérience dans le domaine des besoins humanitaires
                            et de l’analyse des conflits. Ivana, qui a une
                            formation en droit humanitaire et sur les droits
                            humains, a précédemment travaillé sur l’analyse et
                            l’évaluation des besoins humanitaires et la défense
                            des droits humains auprès d’ONG nationales et
                            internationales.
                          </p>

                          <p>
                            Ivana est titulaire d’une maîtrise en droits humains
                            et en action humanitaire de Sciences Po Paris et a
                            passé un semestre à étudier le droit international
                            et l’histoire de la violence à l’Institut de hautes
                            études internationales et du développement de
                            Genève.
                          </p>

                          <p>
                            Ivana parle couramment l’anglais, le français,
                            l’espagnol et le tchèque. Elle peut également
                            communiquer en arabe.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Ricardo}
                          name="Ricardo Fal-Dutra Santos"
                          title="Coordinateur régional pour les Amériques, l’Europe, le Caucase et l’Asie centrale"
                          id="ricardo"
                        >
                          <p>
                            Ricardo Fal-Dutra Santos nous a rejoints en qualité
                            de coordinateur régional pour l’Amérique, l’Europe,
                            le Caucase et l’Asie centrale. Il possède plus de
                            sept ans d’expérience en direction de recherches et
                            d’interventions humanitaires, notamment dans le
                            domaine de la protection, en Angola, en Jordanie, au
                            Mozambique, au Nigéria, en Palestine, en Afrique du
                            Sud et au Soudan du Sud. Il a également travaillé au
                            siège du Comité international de la Croix-Rouge et
                            d’Oxfam, soutenant ainsi des équipes nationales dans
                            une multitude de pays.
                          </p>

                          <p>
                            Ricardo est titulaire d’une maîtrise en sécurité
                            internationale de Sciences Po (Paris, France) et
                            d’une licence en histoire de l’université fédérale
                            de Fluminense (Niterói, Brésil). Il parle anglais,
                            français, portugais et espagnol.
                          </p>
                        </ShowModal>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <Typography> Photos de médias / B-Roll</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>
                      <a href="https://www.internal-displacement.org/sites/default/files/grid2022-broll.zip">
                        B-roll (Zip folder | 578Mb)
                      </a>
                    </p>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4a-content"
                    id="panel4a-header"
                  >
                    <Typography> Infographie</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="row">
                      <ShowModalInfog
                        img={map_global_dld}
                        id="infographic-globalmap"
                        name="Global map"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={SpiralDld}
                        id="infographic-spiral"
                        name="Spiral"
                      ></ShowModalInfog>

                      <ShowModalInfog
                        img={BreakddownDld}
                        id="infographic-breakdown"
                        name="breakdown"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={map_conflict_dld}
                        id="infographic-map-conflict"
                        name="Map - conflict"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={map_disasters_dld}
                        id="infographic-map-disasters"
                        name="Map - disasters"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={map_youth_dld}
                        id="infographic-map-youth"
                        name="Map - youth"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={read_data_conflict}
                        id="read_data_conflict"
                        name="How to read data - conflict and violence"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={read_data_disasters}
                        id="read_data_disasters"
                        name="How to read data - disasters"
                      ></ShowModalInfog>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </Container>
            </Container>

            <Footer
              imageUrl={gridhero}
              txtColor="#ffffff"
              bgColor="#0a3758"
              bgOpacity="0.3"
            />
          </div>
        </div>
      </main>
    </>
  );
  //const launchTime = new Date(Date.UTC(2022, 4, 19, 4, 0, 0));
  //const launchTime = new Date(Date.UTC(2022, 4, 18, 10, 27, 0));
  // const timeNow = new Date();
  // let isTest = false
  // if (typeof window !== 'undefined'){
  // const queryParams = new URLSearchParams(window.location.search)
  //  isTest = queryParams.get("test")}

  // const formattedDate= date =>{

  //   if (launchTime <= timeNow || isTest ){
  //   return indexContent} else {
  //   return comingsoonContent }
  // }
  //return formattedDate(launchTime)
};

// export const query = graphql`
//   query {
//     part1: mdx(slug: { eq: "english-part1" }) {
//       frontmatter {
//         h2
//         h3
//         graph1_caption
//       }
//     }
//     general: mdx(slug: { eq: "generic-english" }) {
//       frontmatter {
//         interact
//         download
//       }
//     }
//   }
// `

export default IndexPageDev;
